export const authRoutes = {
	"/login": "login",
	"/register": "register",
	"/password-reset-options": "password-reset",
	"/send-reset-link": "send-reset-link",
	"/reset-password": "reset-password",
};

export function getAuthMode(location) {
	const mode = new URLSearchParams(location.search).get("auth");
	return Object.values(authRoutes).includes(mode) ? mode : null;
}

/** Change only auth parameters, keeping the page, filters, and anchor intact. */
export function toAuthUrl(location, mode, { type, resetEmail } = {}) {
	const params = new URLSearchParams(location.search);
	params.set("auth", mode);
	if (mode === "register" && type) params.set("authType", type);
	else if (mode !== "register") params.delete("authType");
	if (mode === "password-reset" && resetEmail) params.set("resetEmail", resetEmail);
	else params.delete("resetEmail");
	return `${location.pathname || "/"}?${params.toString()}${location.hash || ""}`;
}

export function withoutAuthUrl(location) {
	const params = new URLSearchParams(location.search);
	["auth", "authType", "intended", "resetEmail"].forEach((key) => params.delete(key));
	const search = params.toString();
	return `${location.pathname || "/"}${search ? `?${search}` : ""}${location.hash || ""}`;
}
